import { render, staticRenderFns } from "./textPdf.vue?vue&type=template&id=55f1f1ec"
import script from "./textPdf.vue?vue&type=script&lang=js"
export * from "./textPdf.vue?vue&type=script&lang=js"
import style0 from "./textPdf.vue?vue&type=style&index=0&id=55f1f1ec&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports